import React, { useState } from 'react'

import { Button, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, TextField } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import NumberFormat from 'react-number-format'

import { useSelector, useDispatch } from 'react-redux'
import { showError, createItem } from '../../../actions/misc/misc.actions'

const useStyles = makeStyles((theme) => ({
	title: {
		marginBottom: 24
	},
	dialogActions: {
		justifyContent: 'flex-start'
	},
	fieldWrapper: {
		minWidth: '400px !important',
		width: '400px !important',
		marginBottom: 20,
		'& .MuiFilledInput-root': {
			minWidth: '400px !important',
			width: '400px !important'
		},
		'& .MuiTextField-root': {
			minWidth: '400px !important',
			width: '400px !important'
		}
	}
}))

function NumberFormatCustom(props) {
	const { inputRef, onChange, ...other } = props

	return (
		<NumberFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						value: values.value
					}
				})
			}}
			decimalScale={2}
			isNumericString
			prefix="$"
		/>
	)
}

const CreditAccountDialog = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const selected = useSelector((state) => state.specific.households.selected)

	let { isShown, setIsShown } = props

	const giftCardVendor = 'giftup'

	const [transactionTitle, setTransactionTitle] = useState('')
	const [amount, setAmount] = useState('')
	const [giftCardCode, setGiftCardCode] = useState('')
	const [type, setType] = useState(null)
	const [transactionTitleError, setTransactionTitleError] = useState(false)
	const [amountError, setAmountError] = useState(false)
	const [typeErr, setTypeErr] = useState(false)
	const addCredit = () => {
		if (!type) return setTypeErr(true)
		if (!areFieldsValid()) {
			dispatch(showError('Please fix form errors.'))
		} else {
			let item = {
				description: transactionTitle,
				amount: Number(amount) * 100 * -1,
				household_id: selected._id,
				type
			}
			if (type === 'gift_card') {
				item['card_number'] = giftCardCode
				item['vendor'] = giftCardVendor
			}

			dispatch(createItem(item)).then(() => {
				closeDialog()
			})
		}
	}

	const areFieldsValid = () => {
		setTransactionTitleError(!transactionTitle ? true : false)
		setAmountError(!amount && type === 'credit' ? true : false)

		return (
			(type === 'credit' && Boolean(transactionTitle) && Boolean(amount)) ||
			(type === 'gift_card' && Boolean(transactionTitle))
		)
	}

	const onTransactionTitleChange = (value) => {
		if (value) {
			if (transactionTitleError) setTransactionTitleError(false)
		}

		setTransactionTitle(value)
	}

	const onAmountChange = (value) => {
		if (value) {
			if (amountError) setAmountError(false)
		}

		setAmount(value)
	}

	const closeDialog = () => {
		setTransactionTitle('')
		setAmount('')
		setType(null)
		setIsShown(false)
	}

	const canProceed = (type === 'gift_card' && giftCardCode > '') || (type === 'credit' && amount > 0)

	return (
		<Dialog
			open={isShown}
			aria-labelledby="form-dialog-title"
			className={classes.dialog}
			onClose={closeDialog}
			PaperProps={{
				style: {
					minWidth: '448px',
					maxWidth: '448px',
					width: '448px'
				}
			}}>
			<DialogTitle className={classes.title}>ADD FUNDS</DialogTitle>
			<DialogContent>
				<div className={classes.fieldWrapper}>
					<TextField
						label="Transaction Title"
						variant="filled"
						value={transactionTitle}
						onChange={(e) => onTransactionTitleChange(e.target.value)}
						error={transactionTitleError}
						helperText={transactionTitleError ? 'Please add a title.' : null}
					/>
				</div>
				<div className={classes.fieldWrapper}>
					<TextField
						label="Type"
						variant="filled"
						value={type}
						select
						onChange={(e) => setType(e.target.value)}
						error={typeErr && !type}
						helperText={typeErr && !type ? 'Please choose a credit type.' : null}>
						<MenuItem value="credit">Credit (error, promo, etc)</MenuItem>
						<MenuItem value="gift_card">Gift Card Redemption</MenuItem>
					</TextField>
				</div>
				{type !== 'gift_card' ? (
					<div className={classes.fieldWrapper}>
						<TextField
							label="Amount"
							variant="filled"
							required={type === 'credit'}
							disabled={type === 'gift_card'}
							value={amount}
							InputProps={{
								inputComponent: NumberFormatCustom
							}}
							onChange={(e) => onAmountChange(e.target.value)}
							error={amountError}
							helperText={amountError ? 'Please add an amount.' : null}
						/>
					</div>
				) : null}
				{type === 'gift_card' ? (
					<div className={classes.fieldWrapper}>
						<TextField
							label="Gift Card Code"
							required={type === 'gift_card'}
							variant="filled"
							value={giftCardCode}
							onChange={(e) => setGiftCardCode(e.target.value)}
						/>
					</div>
				) : null}
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button variant="contained" color="secondary" onClick={addCredit} disabled={!canProceed}>
					ADD FUNDS
				</Button>
				<Button variant="outlined" color="secondary" onClick={closeDialog}>
					CANCEL
				</Button>
			</DialogActions>
		</Dialog>
	)
}

export default CreditAccountDialog
